export default function getHighestDuration(variants: ServiceVariant[]) {
  const durations = variants.map((variant) => variant.duration);

  return Math.max(...durations);
}
